// Small helpers shared by Kova components.

window.Kova = window.Kova || {};

// Formats cents with the shop's money format, e.g. "${{amount}}" or "{{amount_with_comma_separator}} €".
Kova.formatMoney = (cents, format = window.Kova.moneyFormat || '${{amount}}') => {
  const withDelimiters = (value, decimals, thousands = ',', decimal = '.') => {
    const [integer, fraction] = (value / 100).toFixed(decimals).split('.');
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? `${grouped}${decimal}${fraction}` : grouped;
  };
  return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, (_, placeholder) => {
    switch (placeholder) {
      case 'amount_no_decimals':
        return withDelimiters(cents, 0);
      case 'amount_with_comma_separator':
        return withDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return withDelimiters(cents, 0, '.');
      case 'amount_with_apostrophe_separator':
        return withDelimiters(cents, 2, "'");
      default:
        return withDelimiters(cents, 2);
    }
  });
};

// Variant pickers for gifts and add-ons: one dropdown per option (Color, Size...). The matching
// variant id is kept in the picker's hidden [data-gift-select] input.
window.KovaVariantPicker = window.KovaVariantPicker || {
  variants(picker) {
    if (!picker.kovaVariants) {
      try {
        picker.kovaVariants = JSON.parse(picker.querySelector('[data-variant-picker-variants]')?.textContent || '[]');
      } catch {
        picker.kovaVariants = [];
      }
    }
    return picker.kovaVariants;
  },

  // Finds the variant for the chosen values. If that combination is sold out, keeps the value
  // just changed and moves the other dropdowns to the first available combination.
  sync(picker, changedIndex = 0) {
    const variants = this.variants(picker);
    const selects = Array.from(picker.querySelectorAll('.gift-variant__option'));
    const chosen = selects.map((select) => select.value);
    const matches = (variant) => variant.options.every((value, index) => value === chosen[index]);

    let variant = variants.find((item) => item.available && matches(item));
    if (!variant) {
      variant =
        variants.find((item) => item.available && item.options[changedIndex] === chosen[changedIndex]) ||
        variants.find(matches);
      selects.forEach((select, index) => {
        if (variant && Array.from(select.options).some((option) => option.value === variant.options[index])) {
          select.value = variant.options[index];
        }
      });
    }

    const input = picker.querySelector('[data-gift-select]');
    if (variant && input) input.value = variant.id;
    picker.dispatchEvent(new CustomEvent('kova:variant-picked', { bubbles: true, detail: { id: variant?.id, variant } }));
  },

  // Builds a picker in the browser (Shopify recommendations in "Productos adicionales").
  build(product, variants, className) {
    const picker = document.createElement('span');
    picker.className = `gift-variant ${className || ''}`;
    picker.dataset.variantPicker = '';
    picker.kovaVariants = variants.map(({ id, options, available, price, compare_at_price }) => ({
      id,
      options,
      available,
      price,
      compare: compare_at_price,
    }));
    const current = variants.find((variant) => variant.available) || variants[0];

    (product.options || []).forEach((option, index) => {
      const name = typeof option === 'string' ? option : option.name;
      const select = document.createElement('select');
      select.className = 'gift-variant__option';
      select.dataset.optionIndex = index;
      select.setAttribute('aria-label', `${product.title} ${name}`);
      [...new Set(variants.map((variant) => variant.options[index]))].forEach((value) =>
        select.appendChild(new Option(value, value, false, value === current.options[index]))
      );
      picker.appendChild(select);
    });

    const input = document.createElement('input');
    input.type = 'hidden';
    input.value = current.id;
    input.dataset.giftSelect = '';
    picker.appendChild(input);
    return picker;
  },
};

if (!window.kovaVariantPickerBound) {
  window.kovaVariantPickerBound = true;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.gift-variant__option')) return;
    const picker = event.target.closest('[data-variant-picker]');
    if (picker) KovaVariantPicker.sync(picker, parseInt(event.target.dataset.optionIndex) || 0);
  });
}
